import React from "react";
import { MGTypography, TMGTypographyProps } from "../MGTypography/MGTypography";
import { MGTitleStyleDefinitions, TMGTitleStyleDefinitions } from "../../typography";

export type TMGTitleProps = TMGTypographyProps & {
  titleStyleDefinition: TMGTitleStyleDefinitions;
};

export const MGTitle = ({ titleStyleDefinition, ...props }: TMGTitleProps) => (
  <MGTypography
    {...props}
    componentName="mg-title"
    definition={MGTitleStyleDefinitions[titleStyleDefinition]}
  />
);
